var loadedScriptsCallbacks = {};
export function loadScript(url, loadedCB, blockCb) {
    if (!loadedScriptsCallbacks[url]) {
        var loadedScriptCallback = (loadedScriptsCallbacks[url] = {
            loaded: false,
            callbacks: [loadedCB],
        });
        var element = window.document.createElement('script');
        element.src = url;
        element.type = 'text/javascript';
        element.onload = function () {
            loadedScriptCallback.loaded = true;
            for (var ii = 0; ii < loadedScriptCallback.callbacks.length; ii++) {
                loadedScriptCallback.callbacks[ii]();
            }
        };
        element.onerror = blockCb;
        window.document.head.appendChild(element);
    }
    else if (loadedScriptsCallbacks[url].loaded) {
        loadedCB();
    }
    else {
        loadedScriptsCallbacks[url].callbacks.push(loadedCB);
    }
}
export function test_clearScriptsCallbacks() {
    loadedScriptsCallbacks = [];
}
//# sourceMappingURL=loadScript.js.map